import deleteData from "../services/deleteData";
import fetchData from "../services/fetchData";
import patchData from "../services/patchData";
import postData from "../services/postData";
import uploadData from "../services/uploadData";

const handleFetchFirms = async ({ page = "", limit = "", params }: any) => {
  const uri = `firms?page=${page}&limit=${limit}&${params}`;
  const response = fetchData({ uri });
  return response;
};

const handleUploadFirms = async ({ data }: any) => {
  const uri = `firms/upload`;
  const response = uploadData({ data, uri });
  return response;
};

const handleExportFirms = async () => {
  const uri = `firms/export`;
  const response = fetchData({ uri });
  return response;
};

const handleCreateFirm = async (data: any) => {
  const uri = `firms`;
  const response = postData({ data, uri });
  return response;
};

const handleUpdateFirm = async ({ _id, data }: any) => {
  const uri = `firms/${_id}`;
  const response = patchData({ data, uri });
  return response;
};

const handleDeleteFirm = async (data: any) => {
  const uri = `firms`;
  const response = deleteData({ data, uri });
  return response;
};

export {
  handleFetchFirms,
  handleExportFirms,
  handleCreateFirm,
  handleUpdateFirm,
  handleDeleteFirm,
  handleUploadFirms,
};
